export const MENU_IDS = {
    SLIDE_PREVIEW: 'slide-preview-context-menu',
    SLIDE: 'slide-context-menu',
    ELEMENT: 'element-context-menu',
} as const;
